import { useDeviceQueryApi } from "./useDeviceQueryApi";
export function useAlarmsSubscription(options) {
  var queryApi = useDeviceQueryApi();
  return queryApi.useAlarmsSubscription(options);
}